'use client';
import Image from "next/image";
import list from "../../../../public/Images/drawer-menu.svg";
import logo from "../../../../public/Images/header-logo.svg";
import circle1 from "../../../../public/Images/Icons/circle1.svg";
import '../Header/header.style.css';
import Link from "next/link";
import { useState, useEffect } from "react";
import LoadingPage from "../loading/LoadingPage";
import Drawer from "../drawer";

const HeaderPages = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isMounted, setIsMounted] = useState(false);
  const [buttonText, setButtonText] = useState("Book intro call");
  const [isOpen, setOpen] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    const handleScroll = () => {
      setIsScrolled(window.scrollY > 40);
    };

    const handleResize = () => {
      if (window.innerWidth <= 500) {
        setButtonText("Intro call");
      } else {
        setButtonText("Book intro call");
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (!loading) {
      const fragment = window.location.hash.substring(1);
      if (fragment) {
        const section = document.getElementById(fragment);
        if (section) {
          setTimeout(() => {
            const headerHeight = document.querySelector('.header-pages')?.offsetHeight || 100;
            const yOffset = -headerHeight;
            const yPosition = section.offsetTop + yOffset;
            window.scrollTo({ top: yPosition, behavior: "smooth" });
          }, 1000);
        }
      }
    }
  }, [loading]);

  const handleButtonClick = () => {
    if (isMounted) {
      const currentPath = window.location.pathname;

      if (currentPath === '/home') {
        const section = document.getElementById("introCall");
        if (section) {
          const headerHeight = document.querySelector('.header-pages')?.offsetHeight || 100;
          const yOffset = -headerHeight;
          const yPosition = section.offsetTop + yOffset;
          window.scrollTo({ top: yPosition, behavior: "smooth" });
        }
      } else {
        window.location.href = '/introCallPage';
      }
    }
  };

  return (
    <div className="header-pages">
      <Image src={circle1} alt="circle1" className="circle1-pages" width={640} height={1000} />
      <div className={`header-pages-content ${isScrolled ? "scrolled" : ""}`}>
        <button
          onClick={() => setOpen(true)}
          aria-haspopup="dialog"
          aria-expanded={isOpen}
          aria-controls="main-drawer"
          className="header-pages-drawer-container"
          style={{ backgroundColor: 'transparent', border: 'none', cursor: 'pointer' }}
        >
          <Image
            src={list}
            className={`header-pages-logo`}
            alt="Logo"
            width={50}
            height={50}
          />
        </button>
        <Link href="/home#banner" style={{ display: 'grid' }}>
          <div className="logo-wrapper">
            <Image
              src={logo}
              alt="Logo"
              width={110}
              height={60}
              priority
              className="header-pages-logo"
            />

          </div>
        </Link>
        <button className="header-pages-button" onClick={handleButtonClick}>
          {buttonText}
        </button>
      </div>
      <Drawer
        isOpen={isOpen}
        onClose={() => setOpen(false)}
      />
    </div>
  );
};

export default HeaderPages;